import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

// Liturgical color -> HSL for CSS var
export const LITURGY_HSL = {
    green: "138 30% 30%",
    violet: "266 40% 40%",
    white: "44 65% 45%",
    red: "0 60% 34%",
    rose: "345 40% 62%",
    black: "0 0% 15%",
    blue: "215 55% 40%",  // Marian blue
};

export const LITURGY_LABEL = {
    green: "Green",
    violet: "Violet",
    white: "Gold / White",
    red: "Red",
    rose: "Rose",
    black: "Black",
    blue: "Marian Blue",
};

// Which liturgical class to apply based on the day's mood
export const MOOD_CLASS = {
    celebratory: "mood-celebratory",
    joyful: "mood-joyful",
    marian: "mood-marian",
    ordinary: "mood-ordinary",
    penitential: "mood-penitential",
    solemn: "mood-solemn",
    // Legacy fallbacks
    warm: "mood-ordinary",
    sacred: "mood-celebratory",
};
